import React, { useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import { IoTimeOutline } from 'react-icons/io5';

const RecentAlerts = ({recentAlert}) => {
    // Extract alerts array from the nested response structure
    const alertsData = recentAlert?.data?.alerts || recentAlert?.alerts || recentAlert || [];
    // const alerts = [
    //     {
    //         id: 1,
    //         title: "Intruder Detected",
    //         area: "Area Where Detected",
    //         camera: "Camera Name",
    //         time: "Today, 14:32:45",
    //         type: "critical",
    //         borderColor: "#EF4444",
    //         badgeColor: "#EF4444",
    //         badgeText: "Critical"
    //     },
    //     {
    //         id: 2,
    //         title: "Gate Left Open",
    //         area: "Area Where Detected",
    //         camera: "Camera Name",
    //         time: "Today, 13:15:22",
    //         type: "warning",
    //         borderColor: "#F59E0B",
    //         badgeColor: "#0059B3",
    //         badgeText: "Warning"
    //     },
    //     {
    //         id: 3,
    //         title: "Person in No-Go Area",
    //         area: "Area Where Detected",
    //         camera: "Camera Name",
    //         time: "Today, 12:45:10",
    //         type: "Warning",
    //         borderColor: "#F59E0B",
    //         badgeColor: "#0059B3",
    //         badgeText: "Warning"
    //     }
    // ];


    const alerts = Array.isArray(alertsData) ? alertsData.map((item, index) => {
  const date = new Date(item.timestamp);
  const formattedTime = date.toLocaleString('en-US', {
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });

  // Determine alert type and colors based on module
  const getAlertStyle = (moduleName) => {
    const module = moduleName?.toLowerCase() || '';
    if (module.includes('fire')) {
      return { borderColor: "#DC2626", badgeColor: "#DC2626", badgeText: "Fire Alert", type: "critical" };
    } else if (module.includes('no_go') || module.includes('nogo')) {
      return { borderColor: "#EF4444", badgeColor: "#EF4444", badgeText: "Critical", type: "critical" };
    } else if (module.includes('gate')) {
      return { borderColor: "#F59E0B", badgeColor: "#F59E0B", badgeText: "Warning", type: "warning" };
    } else {
      return { borderColor: "#EF4444", badgeColor: "#EF4444", badgeText: "Alert", type: "critical" };
    }
  };

  const alertStyle = getAlertStyle(item.module_name);

  return {
    id: item.alert_id || index,
    title: item.module_name?.replace(/_/g, ' ') || 'Unknown Alert',
    area: item.zone_name || 'Unknown Zone',
    camera: item.camera_name || item.camera_id || 'Unknown Camera',
    time: formattedTime,
    ...alertStyle
  };
}) : [];


    useEffect(() => {
      console.log('Recent Alert Data:', recentAlert);
      console.log('Extracted Alerts:', alertsData);
    }, [recentAlert, alertsData])
    
    return (
        <Card style={{
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            border: "none",
            borderRadius: "12px",
            height: "fit-content",
            maxHeight:'500px',
            overflow:'auto'
        }}>
            <CardBody style={{ padding: "24px" }}>
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h2 style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        color: "#091954",
                        margin: "0"
                    }}>
                        Recent Alerts
                    </h2>
                    <div style={{
                        backgroundColor: "#FFFFFF",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#6B7280",
                        border: "1px solid #E4E4E7"
                    }}>
                        {Array.isArray(alertsData) ? alertsData.length : 0} Total
                    </div>
                </div>

                {/* Alerts List */}
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    {alerts.length === 0 ? (
                        <div style={{
                            backgroundColor: "#FAFAFA",
                            borderRadius: "12px",
                            padding: "40px 20px",
                            textAlign: "center",
                            color: "#9CA3AF"
                        }}>
                            <p style={{ margin: 0, fontSize: "16px" }}>No recent alerts available</p>
                        </div>
                    ) : (
                        alerts.map((alert) => (
                        <div key={alert.id} style={{
                            backgroundColor: "#FAFAFA",
                            borderRadius: "12px",
                            borderLeft: `4px solid ${alert.borderColor}`,
                            padding: "20px",
                            position: "relative"
                        }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div style={{ flex: 1 }}>
                                    {/* Title and Badge */}
                                    <div className="d-flex align-items-center mb-1">
                                        <h3 style={{
                                            fontSize: "18px",
                                            fontWeight: "600",
                                            color: "#111827",
                                            margin: "0 5px 0 0"
                                        }}>
                                            {alert.title}
                                        </h3>
                                        

                                    </div>

                                    {/* Details */}
                                    <div style={{
                                        fontSize: "14px",
                                        color: "#9CA3AF",
                                        lineHeight: "1.5"
                                    }}>
                                    <p style={{ marginBottom: "2px",fontWeight:"600" }}>Areas Where Detected</p>
                                    <div style={{ marginBottom: "4px" }}>{alert.area}</div>
                                    <div>{alert.camera}</div>
                                    </div>
                                </div>

                                {/* Time */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{
                                        backgroundColor: alert.badgeColor,
                                        color: "white",
                                        padding: "3px 17px",
                                        borderRadius: "20px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px"
                                    }}>
                                        <IoTimeOutline size={14} style={{ marginTop: "1px" }} />
                                        {alert.badgeText}
                                    </div>
                                    <div className='mt-1' style={{
                                        fontSize: "14px",
                                        color: "#9CA3AF",
                                        fontWeight: "500",
                                        textAlign: "right",

                                    }}>
                                        {alert.time}
                                    </div>
                                </div>
                            </div>
                        </div>
                        ))
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default RecentAlerts;